import script from "./LoadingCard.vue?vue&type=script&setup=true&lang=js"
export * from "./LoadingCard.vue?vue&type=script&setup=true&lang=js"

import "./LoadingCard.vue?vue&type=style&index=0&id=a363a11e&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a363a11e"]])

export default __exports__